"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26420],{

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 17712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ valuationEffects; },
/* harmony export */   "FA": function() { return /* binding */ valuationSelectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25516);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41208);
/* harmony import */ var lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17065);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44590);









// action types
var CONTEXT = "@feature/valuation";
var actionType = {
    GET_VALUATION_METRICS: "".concat(CONTEXT, "/GET_VALUATION_METRICS"),
    GET_COMPANY_SYMBOL: "".concat(CONTEXT, "/GET_COMPANY_SYMBOL"),
    GET_DEFAULT_VALUATION_METRIC: "".concat(CONTEXT, "/GET_DEFAULT_VALUATION_METRIC"),
    GET_VALUATION_EPS: "".concat(CONTEXT, "/GET_VALUATION_EPS"),
    GET_VALUATION_GROWTH: "".concat(CONTEXT, "/GET_VALUATION_GROWTH"),
    GET_VALUATION_MULTIPLE: "".concat(CONTEXT, "/GET_VALUATION_MULTIPLE"),
    RUN_VALUATION: "".concat(CONTEXT, "/RUN_VALUATION"),
    CREATE_VALUATION_TEMPLATE: "".concat(CONTEXT, "/CREATE_VALUATION_TEMPLATE"),
    GET_VALUATION_TEMPLATE_DETAIL: "".concat(CONTEXT, "/GET_VALUATION_TEMPLATE_DETAIL"),
    UPDATE_VALUATION_TEMPLATE_DETAIL: "".concat(CONTEXT, "/UPDATE_VALUATION_TEMPLATE_DETAIL"),
    DELETE_VALUATION_TEMPLATE_DETAIL: "".concat(CONTEXT, "/DELETE_VALUATION_TEMPLATE_DETAIL")
};
var initialState = {
    valuationSymbol: {
        id: "",
        symbol: ""
    },
    valuationMetricOptions: {
        message: "",
        data: {},
        isError: false,
        isLoading: false
    },
    valuationEPS: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    valuationGROWTH: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    valuationMULTIPLE: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    valuationDefaultMetric: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    valuationResult: {
        data: {
            consensus_high: "",
            consensus_low: "",
            consensus_medium: "",
            country: "",
            current_price: "",
            exchange: "",
            margin_safety: "",
            symbol: "",
            symbol_2: "",
            symbol_3: "",
            target_price: ""
        },
        message: "",
        isError: false,
        isLoading: false
    },
    valuationCreateTemplateResult: {
        message: "",
        isError: false,
        isLoading: false,
        data: {}
    },
    valuationUpdateTemplateResult: {
        message: "",
        isError: false,
        isLoading: false,
        data: []
    },
    valuationDeleteTemplateResult: {
        message: "",
        isError: false,
        isLoading: false,
        data: []
    },
    valuationTemplateDetail: {
        message: "",
        isError: false,
        isLoading: false,
        data: {}
    },
    companySymbol: {
        data: {},
        isError: false,
        isLoading: false,
        message: ""
    },
    metric: {
        comp_id: "",
        item: []
    },
    note: "",
    isMobileView: false,
    valuationMetricKeyword: ""
};
var valuationState = function(state) {
    return state.valuation;
};
var valuationSelectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(valuationState, function(valuation) {
    return {
        valuationSymbol: valuation.valuationSymbol,
        valuationMetricOptions: valuation.valuationMetricOptions,
        valuationDefaultMetric: valuation.valuationDefaultMetric,
        valuationEPS: valuation.valuationEPS,
        valuationGROWTH: valuation.valuationGROWTH,
        valuationMULTIPLE: valuation.valuationMULTIPLE,
        valuationResult: valuation.valuationResult,
        valuationCreateTemplateResult: valuation.valuationCreateTemplateResult,
        valuationUpdateTemplateResult: valuation.valuationUpdateTemplateResult,
        valuationDeleteTemplateResult: valuation.valuationDeleteTemplateResult,
        valuationDetail: valuation.valuationTemplateDetail,
        companySymbols: valuation.companySymbol,
        metric: valuation.metric,
        note: valuation.note,
        isMobileView: valuation.isMobileView,
        valuationMetricKeyword: valuation.valuationMetricKeyword
    };
});
var valuationEffects = {
    getValuationMetrics: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_METRICS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetrics */ .Z.getValuationMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get valuation metrics failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCompanySymbol: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_COMPANY_SYMBOL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(query) {
            var response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getSearchCompany */ .Z.getSearchCompany(query);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company symbol is failed");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(query) {
            return _ref.apply(this, arguments);
        };
    }()),
    getDefaultValuationMetric: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_DEFAULT_VALUATION_METRIC, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetricsDefault */ .Z.getValuationMetricsDefault({
                            symbol: symbol
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get default metric is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getValuationEPS: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_EPS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, metricID, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, metricID = param.metricID;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetricPerID */ .Z.getValuationMetricPerID(symbol, metricID);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get metric EPS is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getValuationGROWTH: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_GROWTH, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, metricID, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, metricID = param.metricID;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetricPerID */ .Z.getValuationMetricPerID(symbol, metricID);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get metric GROWTH is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getValuationMULTIPLE: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_MULTIPLE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, metricID, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, metricID = param.metricID;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetricPerID */ .Z.getValuationMetricPerID(symbol, metricID);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get metric MULTIPLE is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    createValuation: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.RUN_VALUATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, eps_value, growth_value, multiple_value, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, eps_value = param.eps_value, growth_value = param.growth_value, multiple_value = param.multiple_value;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postValuationResult */ .Z.postValuationResult({
                            symbol: symbol,
                            eps_value: eps_value,
                            growth_value: growth_value,
                            multiple_value: multiple_value
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to create valuation is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    createValuationTemplete: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.CREATE_VALUATION_TEMPLATE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var payload, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        payload = param.payload;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postValuationTemplateAdd */ .Z.postValuationTemplateAdd(payload);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to create valuation template is failed");
                    case 7:
                        data = response.data;
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(data.message, constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", data);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getValuationDetailTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_TEMPLATE_DETAIL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateID) {
            var response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationTemplateLoad */ .Z.getValuationTemplateLoad(templateID);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get valuation detail is failed");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(templateID) {
            return _ref.apply(this, arguments);
        };
    }()),
    updateValuationDetailTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.UPDATE_VALUATION_TEMPLATE_DETAIL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var payload, templateID, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        payload = param.payload, templateID = param.templateID;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postValuationTemplateSave */ .Z.postValuationTemplateSave(templateID, payload);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to update valuation detail is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteValuationDetailTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.DELETE_VALUATION_TEMPLATE_DETAIL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateID) {
            var response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postDeleteValuationTemplate */ .Z.postDeleteValuationTemplate(templateID);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to delete valuation detail is failed");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(templateID) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    setValuationSymbol: function(state, action) {
        var _payload = action.payload, id = _payload.id, symbol = _payload.symbol;
        state.valuationSymbol = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationSymbol), {
            id: id,
            symbol: symbol
        });
    },
    setValuationMetric: function(state, action) {
        var _payload = action.payload, compID = _payload.comp_id, item = _payload.item;
        state.metric = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.metric), {
            comp_id: compID,
            item: item
        });
    },
    setValuationNote: function(state, action) {
        state.note = action.payload;
    },
    setValuationResult: function(state, action) {
        state.valuationResult = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult), {
            data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult.data, action.payload),
            isError: false,
            isLoading: false,
            message: ""
        });
    },
    resetValuationSymbol: function(state) {
        state.valuationSymbol = {
            id: "",
            symbol: ""
        };
    },
    resetValuationResult: function(state) {
        state.valuationResult = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult), {
            data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult.data), {
                consensus_high: "",
                consensus_low: "",
                consensus_medium: "",
                country: "",
                current_price: "",
                exchange: "",
                margin_safety: "",
                symbol: "",
                symbol_2: "",
                symbol_3: "",
                target_price: ""
            }),
            isError: false,
            isLoading: false,
            message: ""
        });
    },
    resetValuationDetail: function(state) {
        state.valuationTemplateDetail = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationTemplateDetail), {
            data: {},
            isError: false,
            isLoading: false,
            message: ""
        });
    },
    resetTemplateResult: function(state) {
        state.valuationCreateTemplateResult = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationCreateTemplateResult), {
            data: {},
            isError: false,
            isLoading: false,
            message: ""
        });
    },
    setIsMobileView: function(state, action) {
        state.isMobileView = action.payload;
    },
    setValuationMetricKeyword: function(state, action) {
        state.valuationMetricKeyword = action.payload;
    }
};
var extraReducer = function(builder) {
    builder.addCase(valuationEffects.getValuationMetrics.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationMetricOptions.isError = isError;
            state.valuationMetricOptions.message = message;
        } else {
            state.valuationMetricOptions.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationMetricOptions.data, data);
            state.valuationMetricOptions.message = message;
        }
        state.valuationMetricOptions.isLoading = false;
    }).addCase(valuationEffects.getValuationMetrics.pending, function(state) {
        state.valuationMetricOptions.isLoading = true;
    }).addCase(valuationEffects.getValuationMetrics.rejected, function(state, action) {
        state.valuationMetricOptions.isError = action.payload.isError;
        state.valuationMetricOptions.isLoading = false;
    }).addCase(valuationEffects.getCompanySymbol.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.companySymbol.isError = isError;
            state.companySymbol.message = message;
        } else {
            state.companySymbol.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.companySymbol.data, data);
            state.companySymbol.message = message;
        }
        state.companySymbol.isLoading = false;
    }).addCase(valuationEffects.getCompanySymbol.pending, function(state) {
        state.companySymbol.isLoading = true;
    }).addCase(valuationEffects.getCompanySymbol.rejected, function(state, action) {
        state.companySymbol.isError = action.payload.isError;
        state.companySymbol.isLoading = false;
    }).addCase(valuationEffects.getDefaultValuationMetric.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationDefaultMetric.isError = isError;
            state.valuationDefaultMetric.message = message;
        } else {
            state.valuationDefaultMetric.data = data;
            state.valuationDefaultMetric.message = message;
        }
        state.valuationDefaultMetric.isLoading = false;
    }).addCase(valuationEffects.getDefaultValuationMetric.pending, function(state) {
        state.valuationDefaultMetric.isLoading = true;
    }).addCase(valuationEffects.getDefaultValuationMetric.rejected, function(state, action) {
        state.valuationDefaultMetric.isError = action.payload.isError;
        state.valuationDefaultMetric.isLoading = false;
    }).addCase(valuationEffects.getValuationEPS.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationEPS.isError = isError;
            state.valuationEPS.message = message;
        } else {
            state.valuationEPS.data = data;
            state.valuationEPS.message = message;
        }
        state.valuationEPS.isLoading = false;
    }).addCase(valuationEffects.getValuationEPS.pending, function(state) {
        state.valuationEPS.isLoading = true;
    }).addCase(valuationEffects.getValuationEPS.rejected, function(state, action) {
        state.valuationEPS.isError = action.payload.isError;
        state.valuationEPS.isLoading = false;
    }).addCase(valuationEffects.getValuationGROWTH.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationGROWTH.isError = isError;
            state.valuationGROWTH.message = message;
        } else {
            state.valuationGROWTH.data = data;
            state.valuationGROWTH.message = message;
        }
        state.valuationGROWTH.isLoading = false;
    }).addCase(valuationEffects.getValuationGROWTH.pending, function(state) {
        state.valuationGROWTH.isLoading = true;
    }).addCase(valuationEffects.getValuationGROWTH.rejected, function(state, action) {
        state.valuationGROWTH.isError = action.payload.isError;
        state.valuationGROWTH.isLoading = false;
    }).addCase(valuationEffects.getValuationMULTIPLE.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationMULTIPLE.isError = isError;
            state.valuationMULTIPLE.message = message;
        } else {
            state.valuationMULTIPLE.data = data;
            state.valuationMULTIPLE.message = message;
        }
        state.valuationMULTIPLE.isLoading = false;
    }).addCase(valuationEffects.getValuationMULTIPLE.pending, function(state) {
        state.valuationMULTIPLE.isLoading = true;
    }).addCase(valuationEffects.getValuationMULTIPLE.rejected, function(state, action) {
        state.valuationMULTIPLE.isError = action.payload.isError;
        state.valuationMULTIPLE.isLoading = false;
    }).addCase(valuationEffects.createValuation.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationResult.isError = isError;
            state.valuationResult.message = message;
        } else {
            state.valuationResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult.data, data);
            state.valuationResult.message = message;
        }
        state.valuationResult.isLoading = false;
    }).addCase(valuationEffects.createValuation.pending, function(state) {
        state.valuationResult.isLoading = true;
    }).addCase(valuationEffects.createValuation.rejected, function(state, action) {
        state.valuationResult.isError = action.payload.isError;
        state.valuationResult.isLoading = false;
    }).addCase(valuationEffects.createValuationTemplete.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationCreateTemplateResult.isError = isError;
            state.valuationCreateTemplateResult.message = message;
        } else {
            state.valuationCreateTemplateResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationCreateTemplateResult.data, data);
            state.valuationCreateTemplateResult.message = message;
            valuationEffects.getValuationDetailTemplate(data.id);
        }
        state.valuationCreateTemplateResult.isLoading = false;
    }).addCase(valuationEffects.createValuationTemplete.pending, function(state) {
        state.valuationCreateTemplateResult.isLoading = true;
    }).addCase(valuationEffects.createValuationTemplete.rejected, function(state, action) {
        state.valuationCreateTemplateResult.isError = action.payload.isError;
        state.valuationCreateTemplateResult.isLoading = false;
    }).addCase(valuationEffects.getValuationDetailTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationTemplateDetail.isError = isError;
            state.valuationTemplateDetail.message = message;
        } else {
            state.valuationTemplateDetail.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationTemplateDetail.data, data);
            state.valuationTemplateDetail.message = message;
        }
        state.valuationTemplateDetail.isLoading = false;
    }).addCase(valuationEffects.getValuationDetailTemplate.pending, function(state) {
        state.valuationTemplateDetail.isLoading = true;
    }).addCase(valuationEffects.getValuationDetailTemplate.rejected, function(state, action) {
        state.valuationTemplateDetail.isError = action.payload.isError;
        state.valuationTemplateDetail.isLoading = false;
    }).addCase(valuationEffects.updateValuationDetailTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationUpdateTemplateResult.isError = isError;
            state.valuationUpdateTemplateResult.message = message;
        } else {
            state.valuationUpdateTemplateResult.data = data;
            state.valuationUpdateTemplateResult.message = message;
        }
        state.valuationUpdateTemplateResult.isLoading = false;
    }).addCase(valuationEffects.updateValuationDetailTemplate.pending, function(state) {
        state.valuationUpdateTemplateResult.isLoading = true;
    }).addCase(valuationEffects.updateValuationDetailTemplate.rejected, function(state, action) {
        state.valuationUpdateTemplateResult.isError = action.payload.isError;
        state.valuationUpdateTemplateResult.isLoading = false;
    }).addCase(valuationEffects.deleteValuationDetailTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationDeleteTemplateResult.isError = isError;
            state.valuationDeleteTemplateResult.message = message;
        } else {
            state.valuationDeleteTemplateResult.data = data;
            state.valuationDeleteTemplateResult.message = message;
        }
        state.valuationDeleteTemplateResult.isLoading = false;
    }).addCase(valuationEffects.deleteValuationDetailTemplate.pending, function(state) {
        state.valuationDeleteTemplateResult.isLoading = true;
    }).addCase(valuationEffects.deleteValuationDetailTemplate.rejected, function(state, action) {
        state.valuationDeleteTemplateResult.isError = action.payload.isError;
        state.valuationDeleteTemplateResult.isLoading = false;
    });
};
var valuationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "valuation",
    initialState: initialState,
    // for non-async reducer logic
    reducers: reducers,
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ __webpack_exports__["ZP"] = (valuationSlice);


/***/ }),

/***/ 36296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N8": function() { return /* binding */ TYPE_CUSTOM_PRESET; },
/* harmony export */   "QR": function() { return /* binding */ DEFAULT_TYPE_PRESET; },
/* harmony export */   "qe": function() { return /* binding */ INITIAL_PAGE; },
/* harmony export */   "rz": function() { return /* binding */ KENNETH_FISHER_PRICE_TO_SALES_ID; }
/* harmony export */ });
var INITIAL_PAGE = 1;
var KENNETH_FISHER_PRICE_TO_SALES_ID = 2;
var DEFAULT_TYPE_PRESET = "TEMPLATE_TYPE_GURU";
var TYPE_CUSTOM_PRESET = "TEMPLATE_TYPE_CUSTOM";


/***/ }),

/***/ 9139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export reducers */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17065);
/* harmony import */ var lib_api_screener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70735);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36296);




// Related Modules



// Actions
var CONTEXT = "@side-widget/valuation";
var actionType = {
    // valuation
    GET_VALUATION_TEMPLATE: "".concat(CONTEXT, "/GET_VALUATION_TEMPLATE"),
    GET_VALUATION_METRICS: "".concat(CONTEXT, "/GET_VALUATION_METRICS"),
    POST_DELETE_VALUATION_TEMPLATE: "".concat(CONTEXT, "/POST_DELETE_VALUATION_TEMPLATE"),
    POST_VALUATION_RESULT: "".concat(CONTEXT, "/POST_VALUATION_RESULT"),
    POST_VALUATION_TEMPLATE_SAVE: "".concat(CONTEXT, "/POST_VALUATION_TEMPLATE_SAVE"),
    POST_VALUATION_TEMPLATE_ADD: "".concat(CONTEXT, "/POST_VALUATION_TEMPLATE_ADD"),
    GET_VALUATION_TEMPLATE_LOAD: "".concat(CONTEXT, "/GET_VALUATION_TEMPLATE_LOAD"),
    GET_VALUATION_METRICS_DEFAULT: "".concat(CONTEXT, "/GET_VALUATION_METRICS_DEFAULT"),
    // screener
    GET_SCREENER_CUSTOM: "".concat(CONTEXT, "/GET_SCREENER_CUSTOM"),
    GET_SCREENER_METRICS: "".concat(CONTEXT, "/GET_SCREENER_METRICS"),
    GET_LOAD_PRESET_SCREENER: "".concat(CONTEXT, "/GET_LOAD_PRESET_SCREENER"),
    POST_SCREENER_LIST_RESULT: "".concat(CONTEXT, "/POST_SCREENER_LIST_RESULT")
};
// initial state
var initialState = {
    // valuation
    getValuationTemplate: {
        data: [],
        isLoading: true,
        error: null
    },
    getValuationMetrics: {
        data: {},
        isLoading: true,
        error: null
    },
    getValuationTemplateLoad: {
        data: {},
        isLoading: false,
        error: null
    },
    getValuationMetricsDefault: {
        data: [],
        isLoading: true,
        error: null
    },
    postDeleteValuationTemplate: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    postValuationResult: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    postValuationTemplateSave: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    postValuationTemplateAdd: {
        data: {},
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    // screener
    getScreenerCustom: {
        data: [],
        isLoading: true,
        error: null
    },
    getScreenerMetrics: {
        data: [],
        isLoading: true,
        error: null
    },
    getLoadPresetScreener: {
        data: {},
        isLoading: true,
        error: null
    },
    postScreenerListResult: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    // TODO: Remove this lines after layout feature has been implemented
    currentScreenerData: {
        page: _constants__WEBPACK_IMPORTED_MODULE_3__/* .INITIAL_PAGE */ .qe,
        presetId: _constants__WEBPACK_IMPORTED_MODULE_3__/* .KENNETH_FISHER_PRICE_TO_SALES_ID */ .rz,
        isDataLoaded: false,
        shouldUpdate: false,
        type: ""
    }
};
// Selectors
var valuationState = function(state) {
    return state.mainLayout.valuation;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(valuationState, function(state) {
    return {
        // valuation
        getValuationTemplate: state.getValuationTemplate,
        getValuationMetrics: state.getValuationMetrics,
        getValuationTemplateLoad: state.getValuationTemplateLoad,
        getValuationMetricsDefault: state.getValuationMetricsDefault,
        postDeleteValuationTemplate: state.postDeleteValuationTemplate,
        postValuationResult: state.postValuationResult,
        postValuationTemplateSave: state.postValuationTemplateSave,
        postValuationTemplateAdd: state.postValuationTemplateAdd,
        // screener
        getScreenerCustom: state.getScreenerCustom,
        getScreenerMetrics: state.getScreenerMetrics,
        getLoadPresetScreener: state.getLoadPresetScreener,
        postScreenerListResult: state.getLoadPresetScreener,
        // TODO: Remove this lines after layout feature has been implemented
        currentScreenerData: state.currentScreenerData
    };
}, function(state) {
    return state;
});
// Reducer
var reducers = {
    // TODO: Remove this lines after layout feature has been implemented
    setCurrentScreenerData: function(state, action) {
        state.currentScreenerData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.currentScreenerData, action.payload);
    }
};
// effects
var effects = {
    // getValuationTemplate
    getValuationTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_TEMPLATE, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationTemplate */ .Z.getValuationTemplate();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list valuation template");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getValuationMetrics
    getValuationMetrics: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_METRICS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationMetrics */ .Z.getValuationMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list valuation metrics");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getValuationTemplateLoad
    getValuationTemplateLoad: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_TEMPLATE_LOAD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateId) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationTemplateLoad */ .Z.getValuationTemplateLoad(templateId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when get detail valuation template");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(templateId) {
            return _ref.apply(this, arguments);
        };
    }()),
    // getValuationMetricsDefault
    getValuationMetricsDefault: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_METRICS_DEFAULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(queryString) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationMetricsDefault */ .Z.getValuationMetricsDefault(queryString);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when get valuation metrics default");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(queryString) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postValuationResult
    postValuationResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_VALUATION_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postValuationResult */ .Z.postValuationResult(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when post valuation result");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postValuationTemplateSave
    postValuationTemplateSave: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_VALUATION_TEMPLATE_SAVE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var templateId, requestBody, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        templateId = param.templateId, requestBody = param.requestBody;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postValuationTemplateSave */ .Z.postValuationTemplateSave(templateId, requestBody);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when save valuation template");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postValuationTemplateAdd
    postValuationTemplateAdd: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_VALUATION_TEMPLATE_ADD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postValuationTemplateAdd */ .Z.postValuationTemplateAdd(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when add valuation template");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // screener
    // getScreenerCustom
    getScreenerCustom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_CUSTOM, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getScreenerCustom */ .Z.getScreenerCustom();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list screener custom");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getScreenerMetrics
    getScreenerMetrics: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_METRICS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getScreenerMetrics */ .Z.getScreenerMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list screener metrics");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getLoadPresetScreener
    getLoadPresetScreener: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_LOAD_PRESET_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var presetId, type, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        presetId = param.presetId, type = param.type;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getLoadPresetScreener */ .Z.getLoadPresetScreener(presetId, type);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when get load preset screener");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postDeleteValuationTemplate
    postDeleteValuationTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_DELETE_VALUATION_TEMPLATE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(valuationId) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postDeleteValuationTemplate */ .Z.postDeleteValuationTemplate(valuationId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when delete valuation template");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(valuationId) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postScreenerListResult
    postScreenerListResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_SCREENER_LIST_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postScreenerListResult */ .Z.postScreenerListResult(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when post screener list result");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Extra / Async Reducer
var extraReducers = function(builder) {
    // getValuationTemplate
    builder// Extra reducers for fetch suggestions
    .addCase(effects.getValuationTemplate.pending, function(state) {
        state.getValuationTemplate.error = null;
        state.getValuationTemplate.isLoading = true;
    }).addCase(effects.getValuationTemplate.fulfilled, function(state, action) {
        state.getValuationTemplate.data = action.payload.data;
        state.getValuationTemplate.error = null;
        state.getValuationTemplate.isLoading = false;
        state.getValuationTemplate.message = action.payload.message;
    }).addCase(effects.getValuationTemplate.rejected, function(state, action) {
        state.getValuationTemplate.error = action.error;
        state.getValuationTemplate.isLoading = false;
    }).addCase(effects.getValuationMetrics.pending, function(state) {
        state.getValuationMetrics.error = null;
        state.getValuationMetrics.isLoading = true;
    }).addCase(effects.getValuationMetrics.fulfilled, function(state, action) {
        state.getValuationMetrics.data = action.payload.data;
        state.getValuationMetrics.error = null;
        state.getValuationMetrics.isLoading = false;
        state.getValuationMetrics.message = action.payload.message;
    }).addCase(effects.getValuationMetrics.rejected, function(state, action) {
        state.getValuationMetrics.error = action.error;
        state.getValuationMetrics.isLoading = false;
    }).addCase(effects.getValuationTemplateLoad.pending, function(state) {
        state.getValuationTemplateLoad.error = null;
        state.getValuationTemplateLoad.isLoading = true;
    }).addCase(effects.getValuationTemplateLoad.fulfilled, function(state, action) {
        state.getValuationTemplateLoad.data = action.payload.data;
        state.getValuationTemplateLoad.error = null;
        state.getValuationTemplateLoad.isLoading = false;
        state.getValuationTemplateLoad.message = action.payload.message;
    }).addCase(effects.getValuationTemplateLoad.rejected, function(state, action) {
        state.getValuationTemplateLoad.error = action.error;
        state.getValuationTemplateLoad.isLoading = false;
    }).addCase(effects.getValuationMetricsDefault.pending, function(state) {
        state.getValuationMetricsDefault.error = null;
        state.getValuationMetricsDefault.isLoading = true;
    }).addCase(effects.getValuationMetricsDefault.fulfilled, function(state, action) {
        state.getValuationMetricsDefault.data = action.payload.data;
        state.getValuationMetricsDefault.error = null;
        state.getValuationMetricsDefault.isLoading = false;
        state.getValuationMetricsDefault.message = action.payload.message;
    }).addCase(effects.getValuationMetricsDefault.rejected, function(state, action) {
        state.getValuationMetricsDefault.error = action.error;
        state.getValuationMetricsDefault.isLoading = false;
    }).addCase(effects.getScreenerCustom.pending, function(state) {
        state.getScreenerCustom.error = null;
        state.getScreenerCustom.isLoading = true;
    }).addCase(effects.getScreenerCustom.fulfilled, function(state, action) {
        state.getScreenerCustom.data = action.payload.data;
        state.getScreenerCustom.error = null;
        state.getScreenerCustom.isLoading = false;
        state.getScreenerCustom.message = action.payload.message;
    }).addCase(effects.getScreenerCustom.rejected, function(state, action) {
        state.getScreenerCustom.error = action.error;
        state.getScreenerCustom.isLoading = false;
    }).addCase(effects.getScreenerMetrics.pending, function(state) {
        state.getScreenerMetrics.error = null;
        state.getScreenerMetrics.isLoading = true;
    }).addCase(effects.getScreenerMetrics.fulfilled, function(state, action) {
        state.getScreenerMetrics.data = action.payload.data;
        state.getScreenerMetrics.error = null;
        state.getScreenerMetrics.isLoading = false;
        state.getScreenerMetrics.message = action.payload.message;
    }).addCase(effects.getScreenerMetrics.rejected, function(state, action) {
        state.getScreenerMetrics.error = action.error;
        state.getScreenerMetrics.isLoading = false;
    }).addCase(effects.getLoadPresetScreener.pending, function(state) {
        state.getLoadPresetScreener.error = null;
        state.getLoadPresetScreener.isLoading = true;
    }).addCase(effects.getLoadPresetScreener.fulfilled, function(state, action) {
        state.getLoadPresetScreener.data = action.payload.data;
        state.getLoadPresetScreener.error = null;
        state.getLoadPresetScreener.isLoading = false;
        state.getLoadPresetScreener.message = action.payload.message;
        state.currentScreenerData.isDataLoaded = true;
    }).addCase(effects.getLoadPresetScreener.rejected, function(state, action) {
        state.getLoadPresetScreener.error = action.error;
        state.getLoadPresetScreener.isLoading = false;
    }).addCase(effects.postDeleteValuationTemplate.pending, function(state) {
        state.postDeleteValuationTemplate.error = null;
        state.postDeleteValuationTemplate.isLoading = true;
        state.postDeleteValuationTemplate.isSubmitted = false;
    }).addCase(effects.postDeleteValuationTemplate.fulfilled, function(state, action) {
        state.postDeleteValuationTemplate.data = action.payload.data;
        state.postDeleteValuationTemplate.error = null;
        state.postDeleteValuationTemplate.isLoading = false;
        state.postDeleteValuationTemplate.message = action.payload.message;
        state.postDeleteValuationTemplate.isSubmitted = true;
    }).addCase(effects.postDeleteValuationTemplate.rejected, function(state, action) {
        state.postDeleteValuationTemplate.error = action.error;
        state.postDeleteValuationTemplate.isLoading = false;
        state.postDeleteValuationTemplate.isSubmitted = false;
    }).addCase(effects.postScreenerListResult.pending, function(state) {
        state.postScreenerListResult.error = null;
        state.postScreenerListResult.isLoading = true;
    }).addCase(effects.postScreenerListResult.fulfilled, function(state, action) {
        state.postScreenerListResult.data = action.payload.data;
        state.getLoadPresetScreener.data = action.payload.data;
        state.postScreenerListResult.error = null;
        state.postScreenerListResult.isLoading = false;
        state.postScreenerListResult.message = action.payload.message;
    }).addCase(effects.postScreenerListResult.rejected, function(state, action) {
        state.postScreenerListResult.error = action.error;
        state.postScreenerListResult.isLoading = false;
    }).addCase(effects.postValuationResult.pending, function(state) {
        state.postValuationResult.error = null;
        state.postValuationResult.isLoading = true;
        state.postValuationResult.isSubmitted = false;
    }).addCase(effects.postValuationResult.fulfilled, function(state, action) {
        state.postValuationResult.data = action.payload.data;
        state.postValuationResult.error = null;
        state.postValuationResult.isLoading = false;
        state.postValuationResult.message = action.payload.message;
        state.postValuationResult.isSubmitted = true;
    }).addCase(effects.postValuationResult.rejected, function(state, action) {
        state.postValuationResult.error = action.error;
        state.postValuationResult.isLoading = false;
        state.postValuationResult.isSubmitted = false;
    }).addCase(effects.postValuationTemplateSave.pending, function(state) {
        state.postValuationTemplateSave.error = null;
        state.postValuationTemplateSave.isLoading = true;
        state.postValuationTemplateSave.isSubmitted = false;
    }).addCase(effects.postValuationTemplateSave.fulfilled, function(state, action) {
        state.postValuationTemplateSave.data = action.payload.data;
        state.postValuationTemplateSave.error = null;
        state.postValuationTemplateSave.isLoading = false;
        state.postValuationTemplateSave.message = action.payload.message;
        state.postValuationTemplateSave.isSubmitted = true;
    }).addCase(effects.postValuationTemplateSave.rejected, function(state, action) {
        state.postValuationTemplateSave.error = action.error;
        state.postValuationTemplateSave.isLoading = false;
        state.postValuationTemplateSave.isSubmitted = false;
    }).addCase(effects.postValuationTemplateAdd.pending, function(state) {
        state.postValuationTemplateAdd.error = null;
        state.postValuationTemplateAdd.isLoading = true;
        state.postValuationTemplateAdd.isSubmitted = false;
    }).addCase(effects.postValuationTemplateAdd.fulfilled, function(state, action) {
        state.postValuationTemplateAdd.data = action.payload.data;
        state.postValuationTemplateAdd.error = null;
        state.postValuationTemplateAdd.isLoading = false;
        state.postValuationTemplateAdd.message = action.payload.message;
        state.postValuationTemplateAdd.isSubmitted = true;
    }).addCase(effects.postValuationTemplateAdd.rejected, function(state, action) {
        state.postValuationTemplateAdd.error = action.error;
        state.postValuationTemplateAdd.isLoading = false;
        state.postValuationTemplateAdd.isSubmitted = false;
    });
};
// Slice
var valuationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "valuation",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (valuationSlice);


/***/ }),

/***/ 70735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var screenerURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/screener");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getScreenerCustom = function() {
    return request.get("".concat(screenerURL, "/templates"));
};
var getScreenerMetrics = function() {
    return request.get("".concat(screenerURL, "/preset"));
};
var getLoadPresetScreener = function(id, type) {
    var queryString = type ? "?type=".concat(type) : "";
    return request.get("".concat(screenerURL, "/templates/").concat(id).concat(queryString));
};
var getScreenerUniverse = function() {
    return request.get("".concat(screenerURL, "/universe"));
};
var postScreenerListResult = function(data) {
    return request.post("".concat(screenerURL, "/templates"), data);
};
var getScreenerFavorites = function() {
    return request.get("".concat(screenerURL, "/favorites"));
};
var addScreenerFavorite = function(screenerid, type) {
    return request.post("".concat(screenerURL, "/favorites"), {
        screenerid: screenerid,
        type: type
    });
};
var removeScreenerFavorite = function(screenerid, type) {
    return request.delete("".concat(screenerURL, "/favorites/").concat(screenerid, "?type=").concat(type));
};
var getScreenerFinancial = function() {
    return request.get("".concat(screenerURL, "/metric"));
};
var removeScreenerCustom = function(screenerID) {
    return request.delete("".concat(screenerURL, "/templates/").concat(screenerID));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getScreenerCustom: getScreenerCustom,
    getScreenerMetrics: getScreenerMetrics,
    getLoadPresetScreener: getLoadPresetScreener,
    getScreenerUniverse: getScreenerUniverse,
    postScreenerListResult: postScreenerListResult,
    getScreenerFavorites: getScreenerFavorites,
    addScreenerFavorite: addScreenerFavorite,
    removeScreenerFavorite: removeScreenerFavorite,
    getScreenerFinancial: getScreenerFinancial,
    removeScreenerCustom: removeScreenerCustom
});


/***/ }),

/***/ 17065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable import/named */ 



var valuationURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/valuation");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getValuationTemplate = function() {
    return request.get("".concat(valuationURL, "/all/templates"));
};
var getValuationMetrics = function() {
    return request.get("".concat(valuationURL, "/metrics/lists"));
};
var postDeleteValuationTemplate = function(valuationId) {
    return request.delete("".concat(valuationURL, "/").concat(valuationId));
};
var postValuationResult = function(_param) {
    var symbol = _param.symbol, data = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "symbol"
    ]);
    return request.post("".concat(valuationURL, "/company/").concat(symbol), data);
};
var postValuationTemplateSave = function(templateId, data) {
    return request.put("".concat(valuationURL, "/").concat(templateId), data);
};
var postValuationTemplateAdd = function(data) {
    return request.post("".concat(valuationURL), data);
};
var getValuationTemplateLoad = function(templateId) {
    return request.get("".concat(valuationURL, "/").concat(templateId));
};
var getValuationMetricsDefault = function(_param) {
    var symbol = _param.symbol, data = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "symbol"
    ]);
    return request.get("".concat(valuationURL, "/company/").concat(symbol, "/metrics"), {
        params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data)
    });
};
var getValuationMetricPerID = function(symbol, metricID) {
    return request.get("".concat(valuationURL, "/company/").concat(symbol, "/metrics"), {
        params: {
            metric: metricID
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getValuationTemplate: getValuationTemplate,
    getValuationMetrics: getValuationMetrics,
    postDeleteValuationTemplate: postDeleteValuationTemplate,
    postValuationResult: postValuationResult,
    postValuationTemplateSave: postValuationTemplateSave,
    postValuationTemplateAdd: postValuationTemplateAdd,
    getValuationTemplateLoad: getValuationTemplateLoad,
    getValuationMetricsDefault: getValuationMetricsDefault,
    getValuationMetricPerID: getValuationMetricPerID
});


/***/ })

}]);